module.exports = __webpack_public_path__ + "static/media/female.bdf4579c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female.png
// module id = 373
// module chunks = 0